<template>
    <div>
        <form :action="downloadForm.action" method="post" ref="download">
            <input type="hidden" name="bib" :value="downloadForm.bib">
            <input type="hidden" name="id" :value="downloadForm.id">
            <input type="hidden" name="raceName" :value="downloadForm.raceName">
            <input type="hidden" name="evento" :value="downloadForm.evento">
            <input type="hidden" name="controllo" :value="downloadForm.controllo">
            <input type="hidden" name="distanze" :value="downloadForm.distanze">
            <input type="hidden" name="controllo" :value="downloadForm.controllo">
            <input type="hidden" name="tblGara" :value="downloadForm.tblGara">
            <input type="hidden" name="minutiCache03" :value="downloadForm.minutiCache03">
            <input type="hidden" name="hasRealTime" :value="downloadForm.hasRealTime">
            <input type="hidden" name="locale" :value="downloadForm.locale">
        </form>
    </div>
</template>

<script>
    import BaseVue from '../views/BaseVue'
    import Analytics from "../util/analytics"

    export default {
        extends: BaseVue,
        name: "DownloadCertificate",
        props: [
            'title',
            'image_bg',
            'image_icon',
            'text',
            'detail_text',
            'cta_text',
            'detail_dest',
            'cta_dest',
            'url_video'
        ],data () {
            return {
                downloadForm: {
                    bib: '', // Pettorale
                    id: '', // ID Gara
                    raceNam: '', // anno? 2019?
                    tblGara: 'gara',
                    evento: '',
                    controllo: '',
                    distanze: '', //var distanze='1_0#f#17000#f#Arrivo#f#1#f#1899-12-30 00:00:00#f#1#f#Distance Running#f#10 Miglia del Castello (Risultati ufficiali)#f#10#f#1#f#0,'
                    minutiCache03: '120',
                    hasRealTime: '0', // realtime forse?
                    locale: ''
                }
            }
        },methods: {
            async download(data,event,atl,ranking_id) {
                Analytics.track('file_download','certificate',data.TrackingCategory,event.Name)

                //if (event.distancesList === 'tds.sport') {
                    window.open(this.$store.getters.url + 'certificate/' + data.ID + '/'+ranking_id+'/'+ atl.BibNumber);
                    return  true;
                //}
/*
                this.downloadForm.bib = atl.BibNumber
                this.downloadForm.id = data.ID
                this.downloadForm.raceNam = event.EventDate.substring(0, 4)
                this.downloadForm.evento = event.ID
                this.downloadForm.controllo = ''
                this.downloadForm.distanze = event.distancesList.replace(/#/g, '#f#')
                this.downloadForm.action = 'https://api.tds.sport/ns/static/races/' + data.ID + '/pdf.jsp'
                this.downloadForm.locale = this.$t('idLangTds')
                await this.$nextTick()
                this.$refs.download.submit()*/
            }
        }
    }
</script>

<style scoped>

</style>
